package com.trevorwiebe.timesheet.calendar.domain.usecases

import com.trevorwiebe.timesheet.calendar.domain.CalendarRepository
import com.trevorwiebe.timesheet.core.domain.TSResult

class ReviewTimeOffRequest(
    private val calendarRepository: CalendarRepository,
) {

    suspend operator fun invoke(
        employeeId: String,
        requestId: String,
        approved: Boolean,
    ): TSResult {
        return calendarRepository.reviewTimeOffRequest(employeeId, requestId, approved)
    }

}
